import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { get } from 'lodash'
import {
  TasksRegistrationParticipants,
  RegistrationsAwardLeaders,
  TasksAssessors,
  TasksAssessorsActivityCategoryRegistrations,
  TasksRemovedRegistrationParticipants
} from 'containers/pages'
import { SubTabs, SubTab } from 'components/layout'
import { meta } from 'helpers/decorators'
import { getActiveRole } from 'utils/token'
import { TASKS_OVERVIEW, CONFIGURATION_KEYS, ROLES } from 'constants/enums'

@meta({
  title: 'Registrations',
  intlKey: 'pageTitle.registrations',
  dynamicProp: 'organizations.detail.name'
})
@withRouter
class AwardUnitRegistrations extends Component {
  static propTypes = {
    organisationId: PropTypes.string,
    params: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired
  }

  render() {
    const { params, tasks, organisationId, configuration } = this.props
    const canManageAssessors = get(
      configuration,
      `valuesByOrganizationId[${params.id}][${CONFIGURATION_KEYS.manageAssessors.id}].booleanValue`,
      false
    )
    const { activeOrganization } = this.props
    const role = getActiveRole(activeOrganization)

    return (
      <SubTabs overview={tasks.overview} organisationId={organisationId}>
        <SubTab
          title="Participants"
          intlKey="tabs.participants"
          counter={TASKS_OVERVIEW.AWARD_REGISTRATION.id}
        >
          <TasksRegistrationParticipants
            params={params}
            decoFilter="awardUnitRegistrations"
            decoUpdateOrganizationOverview
            disablePersistedFilter
          />
        </SubTab>
        <SubTab
          title="Award Leaders"
          intlKey="tabs.award_leaders"
          counter={TASKS_OVERVIEW.AL_REGISTRATION.id}
        >
          <RegistrationsAwardLeaders
            params={params}
            decoFilter="awardUnitRegistrations"
            decoUpdateOrganizationOverview
            disablePersistedFilter
          />
        </SubTab>
        {canManageAssessors &&
          <SubTab
            title="Assessor"
            intlKey="tabs.assessors"
            counter={TASKS_OVERVIEW.ASSESSOR_REGISTRATION.id}
          >
            <TasksAssessors
              params={params}
              decoFilter="awardUnitRegistrations"
              decoUpdateOrganizationOverview
              disablePersistedFilter
            />

          </SubTab>}

        {canManageAssessors &&
        <SubTab
            title="Assessor Activity"
            intlKey="tabs.assessors_activity"
            counter={TASKS_OVERVIEW.ASSESSOR_ACTIVITY_REGISTRATION.id}
        >
          <TasksAssessorsActivityCategoryRegistrations
              params={params}
              decoFilter="awardUnitRegistrations"
              decoUpdateOrganizationOverview
              disablePersistedFilter
          />
        </SubTab>}


        {role === ROLES.IF_STAFF_SUPER.u &&
          <SubTab
            title="Removed Participant Registrations"
            intlKey="tabs.removed_participant_registrations"
            aside
          >
            <TasksRemovedRegistrationParticipants
              {...this.props}
              decoFilter="removedRegistrations"
              disablePersistedFilter
            />
          </SubTab>}
      </SubTabs>
    )
  }
}

export default AwardUnitRegistrations
